<template>
  <div v-show="showDialog" class="ubi_translate">
    <div class="mask" />
    <div :class="{new_ubi_translate_box: newUbiStyle}" class="ubi_translate_box">
      <div class="header">
        <div class="info"> {{ $t('common.pleaseSelectLanguage') }} </div>
        <i class="aui_close2" @click="closeDialog">×</i>
      </div>
      <div class="content" style="height: auto">
        <div v-for="item in lanArray" :key="item.key" class="language-detail" @click="changeLanTo(item)">
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    copyTips: {
      type: String,
      default: ''
    },
    newUbiStyle: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showDialog: false,
      lanArray: [
        { key: 'zh', name: '简体中文' },
        { key: 'es', name: 'Español' }, // 西班牙语
        { key: 'ja', name: '日本語' },
        { key: 'de', name: 'Deutsch' }, // 德语
        { key: 'en', name: 'English' }
      ]
    }
  },
  mounted() {
  },
  methods: {
    closeDialog() {
      this.showDialog = false
    },
    changeLanTo(item) {
      this.$emit('changeLanTo', item.key)
      this.showDialog = false
    }
  }
}
</script>
<style lang='scss' scoped>
  .ubi_translate {
    .mask {
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.2);
      z-index: 1001;
    }
    .ubi_translate_box {
      position: fixed;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 360px;
      background: #85BAE5;
      box-shadow: 0px 0px 15px 0px rgba(133,186,229,0.75);
      border-radius: 6px;
      z-index: 1003;
      &.new_ubi_translate_box {
        background: $menuBgcOragne;
        box-shadow: 0px 0px 15px 0px rgba(242,196,109,0.75);
      }
      .header {
        position: relative;
        color: #fff;
        font-size: 12px;
        height: 30px;
        line-height: 30px;
        padding-left: 10px;
        .info {}
        .aui_close2 {
          position: absolute;
          right: 5px;
          top: 5px;
          color: #fff;
          width: 9px;
          height: 9px;
          line-height: 18px;
          font-size: 15px;
          cursor: pointer;
          font-style: normal;
        }
      }
      .content {
        background: #fff;
        color: #323232;
        height: 54px;
        line-height: 54px;
        text-align: center;
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
        .language-detail {
          cursor: pointer;
          color: #323232;
          height: 40px;
          line-height: 40px;
          &:hover {
            background: #F2F2F2;
          }
        }
      }
    }
  }
</style>
